'use strict';

var _toConsumableArray = require("/opt/build/repo/node_modules/@babel/runtime/helpers/toConsumableArray.js");

module.exports = function () {
  var _ref;

  return _toConsumableArray(new Set((_ref = []).concat.apply(_ref, arguments)));
};